import poolDetails from "./poolDetails"
export default poolDetails;
